import dynamic from "next/dynamic";
import WithBackgroundBannerConfig from "./with-background-banner-config";
import WithBackgroundBannerAdvancedConfig from "./with-background-banner-advanced-config";
const WithBackgroundBannerComponent = dynamic(()=>import("./with-background-banner-component"));
export default {
    WithBackgroundBannerComponent,
    WithBackgroundBannerConfig,
    WithBackgroundBannerAdvancedConfig
};
